export default class ErrorUtils {
    static errorLog(program, errorMsg) {
        console.log(`(${program}) -> Error: ${errorMsg}`)
    }

    static errorLogKey(program, key, errorMsg) {
        console.log(`(${program}) -> Key: ${key} Error: ${errorMsg}`)
    }
}